import Flex from "../../shared/components/Flex";
import ModalButton from "../../shared/components/ModalButton";
import Spacer from "../../shared/components/Spacer";
import Text from "../../shared/components/Text";
import useDevice from "../../shared/hooks/useDevice";

function ChoiceModal({ sensor, openDetailModal, openUpdateModal, close }) {
    const device = useDevice();
    const isMobile = device !== 'desktop'

    return (
        <div>
            <Text size={"sm"} noWrap={false}>원하시는 작업을 선택해 주세요.</Text>
            <Spacer direction="vertical" size={24} />
            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton
                    borderRadius={8}
                    height={40}
                    type="default"
                    variant="white"
                    text="정보 수정"
                    onClick={() => {
                        close(); 
                        openUpdateModal(sensor); 
                    }}
                >
                </ModalButton>

                <ModalButton
                    borderRadius={8}
                    type="default"
                    height={40}
                    variant="primary"
                    text="데이터이력 확인"
                    onClick={() => {
                        close();
                        openDetailModal(sensor);
                    }}
                >
                </ModalButton>
            </Flex>
        </div>
    );
}

export default ChoiceModal;
